import React, { useEffect, useRef, useState } from "react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";

import "./SetServicePlace.css";

import { FaArrowRight } from "react-icons/fa";
import { useCookies } from "react-cookie";
import "swiper/css";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";
import { keyboard } from "@testing-library/user-event/dist/keyboard";

export default function SetServicePlaceTime({
  isServicePlaceTimeOpen,
  setIsServicePlaceTimeOpen,
  setDay,
  setTime,
  day,
  time,
  turnTime,
  setreferenceTimeId,
}) {
  const navigate = useNavigate();
  const [cookies, setCookies, removeCookies] = useCookies();
  const pagination = {
    clickable: true,
    // renderBullet: function (index, className = "pg") {
    //   return '<span class="' + className + '">' + " " + "</span>";
    // },
  };
  const [swiper, setSwiper] = useState(null);

  const [isLastSlide, setIsLastSlide] = useState(false);
  // let a = [
  //   {
  //     title: "پنجشنبه",
  //     date: "05/23",
  //     parts: [
  //       {
  //         time: "8-12",
  //         status: "empty",
  //       },
  //     ],
  //   },
  //   {
  //     title: "جمعه",
  //     date: "05/24",
  //     parts: [
  //       {
  //         time: "8-12",
  //         status: "fill",
  //       },
  //       {
  //         time: "12-17",
  //         status: "empty",
  //       },
  //       {
  //         time: "17-21",
  //         status: "fill",
  //       },
  //       {
  //         time: "21-24",
  //         status: "empty",
  //       },
  //     ],
  //   },
  //   {
  //     title: "شنبه",
  //     date: "05/25",
  //     parts: [
  //       {
  //         time: "8-12",
  //         status: "fill",
  //       },
  //       {
  //         time: "12-17",
  //         status: "empty",
  //       },
  //     ],
  //   },
  //   {
  //     title: "یکشنبه",
  //     date: "05/26",
  //     parts: [
  //       {
  //         time: "8-12",
  //         status: "fill",
  //       },
  //       {
  //         time: "12-17",
  //         status: "empty",
  //       },
  //     ],
  //   },
  // ];

  const [a, setA] = useState([]);
  useEffect(() => {
    if (turnTime.length > 0) {
      setA(turnTime);
    }
  }, [turnTime]);

  const [daysIndex, setDaysIndex] = useState(0);
  const [timesIndex, setTimesIndex] = useState(0);
  const [resultIndex, setResultIndex] = useState({
    day: -1,
    time: -1,
  });

  const setserviceplacetimeContainer = useRef();
  useEffect(() => {
    if (isServicePlaceTimeOpen === "true") {
      setserviceplacetimeContainer?.current?.classList?.remove("supReqDown");
      setserviceplacetimeContainer?.current?.classList?.add("supReqUp");
    } else if (isServicePlaceTimeOpen === "false") {
      setserviceplacetimeContainer?.current?.classList?.remove("supReqUp");
      setserviceplacetimeContainer?.current?.classList?.add("supReqDown");
      setTimeout(() => {
        setIsServicePlaceTimeOpen("");
      }, 500);
    } else {
    }
  }, [isServicePlaceTimeOpen]);

  return (
    <>
      <div
        className={`fixed w-full h-screen backdrop-blur-sm  z-[1000] ${
          isServicePlaceTimeOpen ? "" : "hidden"
        }`}
      ></div>
      <div
        ref={setserviceplacetimeContainer}
        className={`w-full  h-[65vw] flex flex-col items-center justify-between rounded-t-[2.8vw]  fixed -bottom-[100vw] bg-color-primary-A z-[1000] ${
          isServicePlaceTimeOpen ? "" : "hidden"
        } `}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div
          className={`w-full flex items-center justify-evenly bg-color-primary-B rounded-t-[2.8vw]  py-[1vw] pt-[5vw]`}
        >
          {a?.map((item, index) => {
            return (
              <div
                key={index}
                id={index}
                onClick={(e) => {
                  setDaysIndex(index);
                  setDay(item.date);
                  swiper.slideTo(index);
                }}
                className={`flex flex-col items-center justify-center font-font_primary_A ${
                  daysIndex === index
                    ? "border-b-[3px] border-[#10242b] text-[#10242B]"
                    : "text-[#474747]"
                }`}
              >
                <span className="text-[3.5vw] font-bold">{item.title}</span>
                <span className="text-[3.5vw] text-[#474747]">
                  {" "}
                  {item.date}
                </span>
              </div>
            );
          })}
        </div>
        <div className="relative w-full h-full flex items-center justify-center bg-color-primary-B">
          <div className="relative w-[90%] h-[90%] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.5)] bg-[#ffe6a2]  text-white text-[8vw] rounded-[1.8vw] px-[4vw] ">
            <Swiper
              className="w-full h-full "
              onSlideChange={(e) => {
                setDaysIndex(e.activeIndex);
              }}
              onSwiper={(swiper) => {
                setSwiper(swiper);
              }}
            >
              {a?.map((item, index) => {
                return (
                  <SwiperSlide key={index}>
                    {a[`${daysIndex}`].parts.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className={`w-full flex items-center justify-between ${
                            a[`${daysIndex}`].parts.length - 1 === index
                              ? ""
                              : "border-b-[1px] border-[#10242b]"
                          }  py-[2vw]`}
                          onClick={(e) => {
                            if (item.status !== "Full") {
                              setResultIndex({
                                day: daysIndex,
                                time: index,
                              });
                              setTime(item.time);
                              if (!day) {
                                setDay(a[0].date);
                              }
                              setreferenceTimeId(item?.reference);
                              setIsServicePlaceTimeOpen("false");
                            }
                          }}
                        >
                          <div className="flex items-center justify-between gap-x-[4vw]">
                            <div className="w-[5vw] h-[5vw] border-[1px] border-color-primary-C flex items-center justify-center rounded-full ">
                              {resultIndex.time === index &&
                                resultIndex.day === daysIndex && (
                                  <div className="w-[2.5vw] h-[2.5vw] bg-color-primary-B  rounded-full "></div>
                                )}
                            </div>
                            <div
                              className={`flex items-center justify-between gap-x-[1vw] text-[4vw] font-font_primary_A font-medium ${
                                item.status === "Empty"
                                  ? "text-[#10242b]"
                                  : "text-color-primary-C"
                              }`}
                            >
                              <span>ساعت</span>
                              <span>{item.time}</span>
                            </div>
                          </div>
                          {item.status === "Full" && (
                            <div className="text-[2.5vw] font-font_primary_A text-color-primary-C">
                              <span>ظرفیت تکمیل</span>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
      </div>
    </>
  );
}
